export default [
    {
        path: '/',
        name: 'start',
        component: () => import('../views/start/StartView.vue'),
        meta: {
            guestOnly: true
        },
    },
    {
        path: '/invite/:token',
        name: 'invite',
        component: () => import('../views/start/InviteView.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/start/LoginView.vue'),
        meta: {
            guestOnly: true
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/start/RegistgatingView.vue'),
        meta: {
            guestOnly: true
        },
    },
]
